import _ from 'lodash';
import queryString from 'query-string';
import { useDebouncedCallback } from 'use-debounce';
import { useLocation, useRouter } from './router/v3Bridge';

const QUERY_STRING_OPTIONS = {
  arrayFormat: 'bracket-separator',
  arrayFormatSeparator: '|',
} as const;

const useQueryStringState = <T extends string | string[]>(
  key: string,
  initialValue: T,
): [T, (newValue: T) => void] => {
  const router = useRouter();
  const location = useLocation();

  const query = queryString.parse(location.search, QUERY_STRING_OPTIONS);

  const value = (query[key] ?? initialValue) as T;

  const { callback: handleSetValue } = useDebouncedCallback((newValue) => {
    if (_.isEqual(newValue, value)) {
      return;
    }

    const newQueryString = queryString.stringify(
      {
        ...query,
        [key]: _.isEqual(newValue, initialValue) ? undefined : newValue,
      },
      QUERY_STRING_OPTIONS,
    );

    router.push(`${location.pathname}?${newQueryString}`);
  }, 200);

  return [value, handleSetValue];
};

export default useQueryStringState;
